import React, { Component } from 'react'
import DashboardLayout from '../layouts/DashboardLayout'
import CheckLoginStatus from '../conditions/CheckLoginStatus'
import Card from '../components/Card'
import Paragraph from '../components/Paragraph'
import Grid from '../components/Grid'
import styled from 'styled-components'

const PlaylistLink = styled.a`
  display: flex;
  background: var(--${props => props.disabled ? 'gray' : props.color});
  color: #fff;
  padding: 0.75rem 1.25rem;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  transition: all 0.2s;
  font-weight: 300;
  border-radius: 1.25rem;
  width: 100%;
  text-decoration: none;
  text-align: center;
  align-items: center;
  justify-content: center;
  &:hover {
    box-shadow: ${props => props.disabled ? 'none' : `0 0 5px var(--${props.color})`};
  }
`
// comment
export default class SEETrainingPPTs extends Component {
  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <DashboardLayout title="SEE MI Training PPTs" backHref="/resources" backText="Resources">
          <Card>
            <Card.Pad>
              <Paragraph str="Below are links to PowerPoint files for counselor training. Please use Microsoft PowerPoint 2010 or later." />
            </Card.Pad>
          </Card>
          <Grid>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://drive.google.com/file/d/1opnkAed7J3r4Yl0i3AUF6ZFj3BO6Vq_x/view" target="_blank">2 Day MI Training PPT</PlaylistLink>
            </Grid.HalfCell>
            <Grid.HalfCell>
              <PlaylistLink color="blue" href="https://drive.google.com/file/d/1FZqczGVsHqW3FfPWcARHWN9sTUv0IPfv/view" target="_blank">Booster Session PPT</PlaylistLink>
            </Grid.HalfCell>
          </Grid>
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/SEETrainingPPTs.js